import { CmsApiThreeSectionSliderBlockData } from 'modules/cms/api/types/blocks/CmsApiThreeSectionSliderBlock';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from 'modules/cms/mappers/CmsMappedBlockWidth';

import { CmsAmpThreeSectionSliderBlock } from './CmsAmpThreeSectionSliderBlock';
import { CmsThreeSectionSliderBlock } from './CmsThreeSectionSliderBlock';

export const CmsThreeSectionSliderBlockMapping: CmsBlockMapping<CmsApiThreeSectionSliderBlockData> =
  {
    invariant: [
      {
        prop: 'headline',
        msg: 'Heading required for Three Section Slider',
      },
      {
        prop: 'sections',
        msg: 'Sections required for Three Section Slider',
      },
    ],
    width: CmsMappedBlockWidth.NARROW,
    Component: CmsThreeSectionSliderBlock,
    AmpComponent: CmsAmpThreeSectionSliderBlock,
  };
